import React, { useState } from 'react'
import AssetManager from './index'

let AssetManagerContext
const { Provider } = (AssetManagerContext = React.createContext())

const AssetManagerProvider = ({ children, projectId, pageId = null, blockId = null, useAbsoluteLink = true }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [placeImage, setPlaceImage] = useState({ callback: null })
    const [settings, setSetting] = useState({})

    return (
        <Provider value={{ projectId, pageId, blockId, setIsOpen, setPlaceImage, setSetting, useAbsoluteLink }}>
            <AssetManager
                isOpen={isOpen}
                onPlaceImage={placeImage.callback}
                onClose={() => setIsOpen(false)}
                projectId={projectId}
                settings={settings}
            />
            {children}
        </Provider>
    )
}

export { AssetManagerContext, AssetManagerProvider }
